<div class="modal-content">
  <div class="modal-header" id="social-share-btns-modal-header">
        <h5 class="modal-title" title="select-exam">Share post to</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
      <div class="modal-info" id="social-share-btns-body">
        <div class="row p-3">
          <!-- <share-buttons theme="material-dark" show="11" [include]="['facebook', 'whatsapp', 'linkedin', 'telegram', 'twitter', 'messenger', 'email', 'copy']" [url]="urlToShare" (opened)="clickedShareButton()"></share-buttons> -->
        </div>
      <div class="row mt-3">
          <div class="col-12 text-right">
              <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="bsModalRef.hide()" data-toggle="modal">Close</button>
          </div>
      </div>

      </div>
      <!-- BODY Of POPUP ENDS -->
  </div>
</div>
